import { FaSolidPause, FaSolidPlay } from "solid-icons/fa";
import { Show, type VoidComponent, createMemo, onMount, useContext } from "solid-js";
import { playerContext } from "../..";
import { PlayButtonWrapper } from "./styled";
import type { PlayButtonProps } from "./types";

const PlayButton: VoidComponent<PlayButtonProps> = (props) => {
	const { player, handleTogglePlayer } = useContext(playerContext);
	onMount(() => {});

	const showPause = createMemo(() => {
		const track = player.queue[player.track];

		if (!track) return false;

		if (props.tracklistUuid && !props.track) return track.tracklistUuid === props.tracklistUuid && player.playing;
		return track.id === props.track?.id && player.playing;
	});

	const handleClick = (e: MouseEvent) => {
		e.stopImmediatePropagation();
		if (showPause()) handleTogglePlayer(props.resume);
		else props.onClick();
	};

	return (
		<>
			<PlayButtonWrapper
				diameter={props.diameter}
				onclick={handleClick}
				disabled={player.loading}
				alt={props.alt}
				class={props.class}
			>
				<Show when={showPause()} fallback={<FaSolidPlay style={props.alt ? {} : { "margin-left": "2px" }} />}>
					<FaSolidPause />
				</Show>
				{props.text}
			</PlayButtonWrapper>
		</>
	);
};
export default PlayButton;
